import * as React from 'react';
/**
 * @hidden
 */
export var ChartContext = React.createContext(null);
ChartContext.displayName = 'ChartContext';
//# sourceMappingURL=ChartContext.js.map